import script from "./LanguageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageModal.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageModal.vue?vue&type=style&index=0&id=573d2ed3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573d2ed3"]])

export default __exports__